const FORMAT_EXCEL_EXPORT_TYPE_ENUM = Object.freeze({
  STRING: String,
  BOOLEAN: Boolean,
  DATE: Date,
  NUMBER: Number,
});

export default FORMAT_EXCEL_EXPORT_TYPE_ENUM;